<ng-container *ngIf="{isShow: (show$ | async)} as streams$">
  <div class="wrap" #target>
    <ng-content select="target"></ng-content>
  </div>
  <int-portal-slot
    [show]="streams$.isShow"
    [targetRef]="target"
    [satellitePayload]="options"
    (targetIsNotVisible)="targetIsNotVisible()"
    [viewportRef]="viewportRef"
  >
    <ng-template intPortalSlotTemplate>
      <int-dropdown-area
        class="drop-area"
        [style]="dropStyles"
        [excludeElementsForClickOutside]="target"
        (clickOutside)="toggle()"
      >
        <ng-content select="content"></ng-content>
      </int-dropdown-area>
    </ng-template>
  </int-portal-slot>
</ng-container>



